var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classNames},[_c('FontAwesomeIcon',{attrs:{"icon":"jw-crown-icon","size":"sm"}}),_vm._v(" "+_vm._s(_vm.$t('WEBAPP_FREEMIUM_TAG'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }